type JsonData = Record<string, string | number>[];

export const downloadCSV = (
  data: string,
  filename = 'citation_data.csv',
): void => {
  try {
    const jsonData: JsonData = JSON.parse(data);
    if (!Array.isArray(jsonData) || jsonData.length === 0) return;

    const headers = Object.keys(jsonData[0]);
    const csvContent = [
      headers.join(','),
      ...jsonData.map((row) =>
        headers
          .map((header) => {
            const value = row[header];
            return typeof value === 'number'
              ? value.toString()
              : `"${value.toString().replace(/"/g, '""')}"`;
          })
          .join(','),
      ),
    ].join('\n');

    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);

    link.setAttribute('href', url);
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url); // Clean up the URL object
  } catch (error) {
    console.error('Error creating CSV:', error);
  }
};
